import React, { useContext, useState, useEffect, useRef } from "react";

import Result from "./Result.jsx"
import NoResults from './NoResults.jsx';
import ResultsLoading from './ResultsLoading.jsx';
import { DealerContext } from '@contexts/DealerContext.jsx';
import { useSpring, animated } from '@react-spring/web'
import { useDrag } from '@use-gesture/react'
import MapPin from '@assets/MapPin.svg';
import Close from '@assets/Close.svg';
import { translate } from "../../../utility/strings.js";

const OpenResults = ({ results }) => {

  const [open, setOpen] = useState(false);
  const { openDealers, setOpenDealers, setOpenDealerId, openDealerId, loading } = useContext(DealerContext);
  const [{ y }, api] = useSpring(() => ({ y: 0 }));
  const resultsRef = useRef(null);
  const offsets = useRef({
    peakOffset: 220,
    topOffset: window.innerHeight - 100
  });

  const handleHandleClick = () => {
    if(open){
      close();
    }else{
      setOpen(true);
    }
  }

  const close = () => {
    setOpen(false);
    setOpenDealers([]);
    setOpenDealerId(null);
  }

  const bind = useDrag(({ down, movement: [mx, my], velocity: [vx, vy] }) => {
    const offset = open ? offsets.current.topOffset : offsets.current.peakOffset;
    if(openDealers.length > 0){
      if(down){
        api.start({ y: my - offset })
      } else if (!open && my < 0 && (my * -2 > offset || vy > 1)) {
        setOpen(true);
      }else if (open && my > 0 && (my * 3 > offset || vy > 1)) {
        setOpen(false);
      } else if ( !open && my > 0 && ( my > offset / -3 || vy > 1) ){
        close();
      } else {
        api.start({ y: -1 * offset })
      }
    }
  });

  const bindProps = bind();

  useEffect(() => {
    if(openDealers.length && window.innerHeight - 100 > resultsRef.current?.getBoundingClientRect().height + 100){
      offsets.current.topOffset = resultsRef.current?.getBoundingClientRect().height + 50;
    }else{
      offsets.current.topOffset = window.innerHeight - 100;
    }
    if(openDealers.length > 0){
      if(!open){
        api.start({ y: -1 * offsets.current.peakOffset })
      } else {
        api.start({ y: -1 * offsets.current.topOffset })
      }
    }else{
      api.start({ y: 0 })
    }
  }, [open, openDealers]);

  return (
    <animated.div style={{ y, touchAction: 'none' }} {...bindProps} className={`open_results results_sidebar ${open ? 'open' : ''}`}>
      <button className="button--handle lg:hidden" onClick={handleHandleClick}>Toggle Results</button>
      <button type="button" className="drawer__close-icon" onTouchStart={close} onClick={close}>
        <Close />
        <span class="sr-only">Close</span>
      </button>
      <div className="ft_dealer-locator__results__list" ref={resultsRef}>
        {loading ?
          <ResultsLoading />
          :
          (openDealers.length ?
            <>
              <div className="ft_dealer-locator__results__utility-bar">
                <span className="ft_dealer-locator__results-icon">
                  <MapPin />
                </span>
                <h1 className="ft_dealer-locator__results__search-bar__title subtitle-2">{translate("dealer_locator.dealer_count", "Stores", openDealers.length)}</h1>
              </div>
              {openDealers.map((dealer, index) => <Result key={`result-${index}`} index={index} dealer={dealer} className={"ft_dealer-locator__results__list__item"} />)}
            </>
            :
            <NoResults />
          )
        }
      </div>
    </animated.div>
  );

}

export default OpenResults;
